/**
 * 프리미엄 확인 결과 캐시 — 새로고침 시 구독 확인 로딩 없이 즉시 진입용.
 * 화면 진입 게이트만 캐시할 뿐, 데이터 접근 권한은 Firestore 보안 규칙이
 * 서버에서 강제하므로 보안이 약화되지 않는다. 백그라운드 재검증이
 * 만료/해지를 감지하면 즉시 차단된다.
 */
const STORAGE_KEY = 'ilgijang.premiumCache';
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7일 — 이후엔 다시 블로킹 확인

interface CacheEntry {
  premium: boolean;
  ts: number;
}

function readCache(): Record<string, CacheEntry> {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}');
  } catch {
    return {};
  }
}

/** 캐시상 프리미엄이 확실할 때만 true (없음/만료/false 는 모두 false → 기존 블로킹 확인) */
export function loadCachedPremium(uid: string): boolean {
  const entry = readCache()[uid];
  return !!entry && entry.premium === true && Date.now() - entry.ts < TTL_MS;
}

export function saveCachedPremium(uid: string, premium: boolean): void {
  try {
    const cache = readCache();
    cache[uid] = { premium, ts: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch {
    // 저장 불가 환경 — 다음에도 블로킹 확인을 할 뿐 동작엔 지장 없음
  }
}
